var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"credit-card"},[_c('span',{staticClass:"type"},[_c('img',{attrs:{"src":_vm.data.processor.image['@2x'],"width":"30"}})]),_c('span',{staticClass:"lastDigits"},[_vm._v(_vm._s(_vm.data.lastDigits))]),_c('button',{staticClass:"trash",on:{"click":function($event){return _vm.destroy(_vm.data.id)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }